{
  "SLA": {
    "HEADER": "Szolgáltatási szintű megállapodások",
    "ADD_ACTION": "SLA hozzáadása",
    "ADD_ACTION_LONG": "Új SLA-szabályzat létrehozása",
    "DESCRIPTION": "A szolgáltatási szintű megállapodások (SLA) egyértelmű elvárásokat rögzítenek a csapat és az ügyfelek között. Meghatározzák a válasz- és megoldási idők normáit, így biztosítják az elszámoltathatóságot és az egységes, magas színvonalú élményt.",
    "LEARN_MORE": "További információ az SLA-ról",
    "LOADING": "SLA-k betöltése",
    "PAYWALL": {
      "TITLE": "Váltson magasabb csomagra az SLA-k létrehozásához",
      "AVAILABLE_ON": "Az SLA funkció csak a Business és Enterprise csomagokban érhető el.",
      "UPGRADE_PROMPT": "Váltson magasabb csomagra, és férjen hozzá olyan speciális funkciókhoz, mint a csapatkezelés, az automatizálás, az egyéni attribútumok és sok más.",
      "UPGRADE_NOW": "Váltás most",
      "CANCEL_ANYTIME": "A csomagját bármikor módosíthatja vagy lemondhatja"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Az SLA funkció csak a fizetős csomagokban érhető el.",
      "UPGRADE_PROMPT": "Váltson fizetős csomagra, és férjen hozzá olyan speciális funkciókhoz, mint a naplók, az ügynökkapacitás és sok más.",
      "ASK_ADMIN": "A csomagváltáshoz forduljon a rendszergazdához."
    },
    "LIST": {
      "404": "Ebben a fiókban nincs elérhető SLA.",
      "EMPTY": {
        "TITLE_1": "Vállalati P0",
        "DESC_1": "Nagyvállalati ügyfelek által jelzett problémák, amelyek azonnali figyelmet igényelnek.",
        "TITLE_2": "Vállalati P1",
        "DESC_2": "Nagyvállalati ügyfelek által jelzett problémák, amelyeket gyorsan vissza kell igazolni."
      },
      "BUSINESS_HOURS_ON": "Nyitvatartás bekapcsolva",
      "BUSINESS_HOURS_OFF": "Nyitvatartás kikapcsolva",
      "RESPONSE_TYPES": {
        "FRT": "Első reakció idő küszöbértéke",
        "NRT": "Következő válaszidő küszöbértéke",
        "RT": "Megoldási idő küszöbértéke",
        "SHORT_HAND": {
          "FRT": "FRT",
          "NRT": "NRT",
          "RT": "RT"
        }
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "SLA neve",
        "PLACEHOLDER": "SLA neve",
        "REQUIRED_ERROR": "Az SLA nevének megadása kötelező",
        "MINIMUM_LENGTH_ERROR": "Minimum 2 karakter hosszúnak kell lennie",
        "VALID_ERROR": "Kizárólag betűk, számok, kötőjel és alulvonás szerepelhet"
      },
      "DESCRIPTION": {
        "LABEL": "Leírás",
        "PLACEHOLDER": "SLA prémium ügyfeleknek"
      },
      "FIRST_RESPONSE_TIME": {
        "LABEL": "Első reakció idő",
        "PLACEHOLDER": "5"
      },
      "NEXT_RESPONSE_TIME": {
        "LABEL": "Következő válaszidő",
        "PLACEHOLDER": "5"
      },
      "RESOLUTION_TIME": {
        "LABEL": "Megoldási idő",
        "PLACEHOLDER": "60"
      },
      "BUSINESS_HOURS": {
        "LABEL": "Nyitvatartás",
        "PLACEHOLDER": "Csak nyitvatartási időben"
      },
      "THRESHOLD_TIME": {
        "INVALID_FORMAT_ERROR": "A küszöbértéknek nullánál nagyobb számnak kell lennie"
      },
      "EDIT": "Szerkesztés",
      "CREATE": "Létrehozás",
      "DELETE": "Törlés",
      "CANCEL": "Mégse"
    },
    "ADD": {
      "TITLE": "SLA hozzáadása",
      "DESC": "Megbízható ígéretek a kiváló szolgáltatásért!",
      "API": {
        "SUCCESS_MESSAGE": "Az SLA hozzáadása sikeres",
        "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra"
      }
    },
    "DELETE": {
      "TITLE": "SLA törlése",
      "API": {
        "SUCCESS_MESSAGE": "Az SLA törlése sikeres",
        "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra"
      },
      "CONFIRM": {
        "TITLE": "Törlés megerősítése",
        "MESSAGE": "Biztosan törölni szeretné: ",
        "YES": "Igen, Törlés ",
        "NO": "Nem, Mégse "
      }
    },
    "EVENTS": {
      "TITLE": "SLA-mulasztások",
      "FRT": "Első reakció idő",
      "NRT": "Következő válaszidő",
      "RT": "Megoldási idő",
      "SHOW_MORE": "további {count}",
      "HIDE": "{count} sor elrejtése"
    }
  }
}
